'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _i18next = require('i18next');

var _i18next2 = _interopRequireDefault(_i18next);

var _i18nextBrowserLanguagedetector = require('i18next-browser-languagedetector');

var _i18nextBrowserLanguagedetector2 = _interopRequireDefault(_i18nextBrowserLanguagedetector);

var _i18nextXhrBackend = require('i18next-xhr-backend');

var _i18nextXhrBackend2 = _interopRequireDefault(_i18nextXhrBackend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// use query to render ui in client side.. 
_i18next2.default.use(_i18nextBrowserLanguagedetector2.default).use(_i18nextXhrBackend2.default).init({
  whitelist: ['en', 'vi'],
  fallbackLng: 'en',

  // have a common namespace used around the full app
  ns: ['common'],
  defaultNS: 'common',

  interpolation: {
    escapeValue: false // not needed for react!!
  }
});

exports.default = _i18next2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/i18n-client.js
// module id = 1546
// module chunks = 0